<template>
  <div class="Repecharge">
    <!-- <my_image :src="title" :width="'50vw'"></my_image>
         <div class="tip">点击视频观看复赛规则介绍</div>
         <my_video :v="v" :inputStyle="videoStyle"></my_video> -->
    <div class="splitView">
    <div class="preRules">
      恭喜你进入AI算法挑战活动全国决赛附加赛，附加赛将决定你是否能赢得金银铜牌，快来挑战一下吧！
      <br>
      <br>
      本次比赛需要进入腾讯会议，请按照网页底部的说明进入会议并开启摄像头
      <br>
      <br>
      本次比赛将进入奥佳睿的地图页，请尽你所能地在半小时内多闯关吧！
      当前按钮是灰色（不可点击）的，等待十点前网页会自动刷新，按钮变成蓝色后就可以开始附加赛啦，现在请先阅读下方的 FAQ 和考场纪律吧。
      <br>
      <br>
      考试时间： 10：00-10：30
      <br/>
      <br/>
      <div class="note"><span>C++ 选手</span>请注意，本次比赛中由于系统限制，代码中如出现合理的重复声明（如两个分开的<pre>for (int i ;;)</pre>) 也会被视为错误，请在代码中避免重复声明，如将<pre>int i</pre>写在循环外面只声明一次即可。</div>
    </div>
    <div class="buttons">
      <!-- <span title="比赛开始时按钮将自动刷新，无需手动刷新页面"><my_button :value="'进入比赛'" :inputStyle="buttonStyle" :disable="disable" @click.native="jump"></my_button> -->
      <!-- <span class="split"></span> -->
      <my_button :value="'进入会议'" :inputStyle="buttonStyle" class="meeting"  @click.native="jumpMeeting"></my_button>
    <div>
      也可使用腾讯会议号码入会：{{mettingNumber}}
    </div>
    </span>
    <my_button :value="'开始挑战'" :inputStyle="buttonStyle" :disable="disable" @click.native="goto"></my_button>
    <!-- <my_button v-for="(url, index) in game_urls" :value="button_titles(index)" :inputStyle="buttonStyle" :disable="disable" :class="{passed: (problem_status[index] > 0)}" @click.native="goto(url)"></my_button> -->
    <!-- <vue_markdown :source="mdfile" id="rule"></vue_markdown> -->
</div>
</div>
    <div class="rules">
      <div>FAQ</div>
      <div v-for="faq in faqs" class="faq">
        <div class="q">{{faq.q}}</div>
        <div class="a" v-html="faq.a"></div>
        <div class="img" v-if="faq.imgs">
          <img v-for="i in faq.imgs" alt="" :src="i.src" :width="i.width" />
        </div>
      </div>
    </div>
 
  </div>
</template>

<script>
 // @ is an alias to /src
 import MyImage from '@/components/Image.vue';
 import MyVideo from '@/components/Video.vue';
 import MyButton from '@/components/Button.vue';
  import VueMarkdown from 'vue-markdown'
  import pdfvuer from 'pdfvuer'
 import moment from 'moment'
 export default {
   name: '',
   computed: {
     faqs () {
       return  [
         {q: '如何才能完成这场附加赛？',
          a:'完成这场附加赛只需要尽可能闯关即可，不要求全部完成。没有硬性的关卡数限制，我们将根据所有人的闯关情况进行排名。',
          imgs: []

         },
         {q: '我该如何进入腾讯会议？',
          a:'点击页面上略带紫色的”进入会议“按钮，可以打开会议链接，点击加入会议，然后点击打开腾讯会议，即可加入考试会议。',
          imgs: [{src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA4.png', width: '300px'},{src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA5.png', width: '400px'}, {src: '/oss/images/plus2021/%E6%8F%90%E7%A4%BA6.png', width: '800px'}]
         },
         {q: '有哪些考场纪律？',
          a: '1. 监考老师不回答问题。<br>2. 比赛期间，请打开摄像头并静音，需要露出你的脸，确保本人参加，会全程录像。没有摄像头的我们会识别. <br>3. 进入考场后，<b>请请在腾讯会议中修改你的名字为全名。如果不修改，那么附加赛没有你的成绩。</b>'},
         {
           q: '关卡中的视频影响闯关时间怎么办？',
           a: '视频可以在右上角找到跳过按钮。'
         },
         {
           q: '关卡中可以使用哪些函数？',
           a:'页面最左侧可以找到“指挥库”，点开即为可用的函数列表'
         },
         {q: '我的浏览器有问题？',
          a: '推荐使用谷歌浏览器，如果你的浏览器显示有问题，请换<a href="https://www.google.cn/intl/zh-CN/chrome/" >谷歌浏览器</a>。 '},
         {q: '可以提前交卷吗？',
          a:'如果提前做完题目，可以关闭浏览器，离开考场。'},
       ]
     },
     title () {
       return 'https://assets.koudashijie.com/images/magic-rush-bg.jpeg'
     },
     v() {
       return {
         src:'https://assets.koudashijie.com/videos/AI%E4%B8%96%E9%9D%92%E8%B5%9B%E5%A4%8D%E8%B5%9B%E8%A7%86%E9%A2%91%EF%BC%88%E6%97%A0%E7%BD%91%E5%9D%80%EF%BC%89.mp4'
       }
     },
     videoStyle() {
       return {
         width: '40vw',
         'margin-top': 0,
         height: 'auto'
       }
     },
     mdfile() {
       return rulemd
     },
     buttonStyle() {
       return {
         'border-radius': '5px',
         'margin-top': '2vw',
         'width': '8em'
       }
     },
     game_urls () {
       return this.problem_urls.map(u =>
         this.$store.state.loginLink+`&redirect=${encodeURIComponent(u)}&accessToken=${this.$store.state.auth.token.token}`
      )
     },
     mettingNumber() {
       let user = this.user || this.$store.state.auth.user
       if(user?.group  == 1) {
         return '427294966'
       } else
       return '112867033'
     },
     /* myClassroom() { */
       /* return this.$store.state.auth.classroom*/
       /* return this.$store.state.classrooms[this.$store.state.auth.classroom[0].classroom_id] */
     /* } */

   },
   data () {
     return {
       disable: true,
       interval: null,
       user: null,
       
       numPages: 0,
       pdfdata: undefined,
       problem_urls: [],
       problem_status: [0, 0, 0, 0, 0]
     }
   },
   methods: {
     button_titles (index) {
       let origTitles = ['第一题', '第二题', '第三题', '第四题', '第五题']
       return this.problem_status[index] ? '已完成' : origTitles[index]
  }    ,
     getPdf () {
       this.pdfdata = pdfvuer.createLoadingTask('/oss/pdf/plusRule.pdf');
       this.pdfdata.then(pdf => {
         this.numPages = pdf.numPages
         console.log(this.numPages)
       })
     },
 
     jumpMeeting() {
       let map = {
         '427294966': 'XdHEwDoXRvLw',
         '112867033': 'Q6tngyc124z4',
       }
       let url = 'https://meeting.tencent.com/dm/' + map[this.mettingNumber]
       window.open(url, '_blank')
     },
     fetchStatus() {
       this.$http.get('api/plus_rank/me?round=2021-3').then(res => {
         this.problem_status = [
           res.data.scores1,
           res.data.scores2,
           res.data.scores3,
           res.data.scores4,
           res.data.scores5,
         ]
       });
     },
     goto() {
       console.log("click goto")
       let user = this.user || this.$store.state.auth.user
       // cs5 /play/568ad069a6584820004437f2?course=569ed916efa72b0ced971447&course-instance= // cs5
       /* let redirect = '/play/56462c1133f1478605ebd018?course=56462f935afde0c6fd30fc8d&course-instance=' // cs4 */
       let redirect = '/play/5dd31cd3e8919b488b036a91?course=5e27600d1c9d440000ac3ee7&course-instance=' // ch3
       if(user.language === 'python') {
         redirect += '65a74224662ea30216305816&campaign-page=1&classroom-id=65a73d19199060a0a00c4d9b'
       } else {
         redirect += '65a74e477535cf4edd0fa3c3&campaign-page=1&classroom-id=65a73d19be512cd87ab9587f'
       }
       let url = this.$store.state.ozarialink + this.$store.state.auth.token.token + `&redirect=${encodeURIComponent(redirect)}`
       window.open(url, "_blank")
     },
     jump() {
       let user = this.user ||  this.$store.state.auth.user
       let redirect ='/play/level/resource-tycoon'
       let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
       window.open(url)
     },
     correctTime() {
       return moment(+new Date() + this.$store.state.timeDelay)
     },

   },
    created() {

    },
   mounted() {
     /* this.getPdf() */
     let user = this.user ||  this.$store.state.auth.user
     /* if(!user || !myClassroom)
      *   {
      *     this.$router.push({name: 'frontpage'})
      *   } */
     let that = this
     /* let startTime = moment(myClassroom.begin_time)
      * let timeLimit1 = moment(myClassroom.begin_time).subtract(4, 'minutes');
      * let timeLimit2 = moment(myClassroom.begin_time).subtract(3, 'minutes');
      * let endTime = moment(myClassroom.end_time) */
     /* this.$http.get('/api/me/plus_problems').then(res=> {
      *   this.problem_urls = res.data
      * }) */

     /* setTimeout(this.fetchStatus, 2000); */
     let startTime = moment('2024-1-20 10:00:00')
     let timeLimit1 = moment('2024-1-20 10:00:00').subtract(7, 'minutes');
     let timeLimit2 = moment('2024-1-20 10:00:00').subtract(1, 'minutes');
     let endTime = moment('2024-1-20 10:30:00')
     let nowTime = this.correctTime()
     if(nowTime.isBefore(endTime))
       {
         if(nowTime.isAfter(startTime))
           {
             that.disable = false
           }
         else{
           that.interval = setInterval(function() {
             if(that.correctTime().isAfter(timeLimit1))
               {
                 clearInterval(that.interval)
                 that.interval = setInterval(function() {

                   if(that.correctTime().isAfter(timeLimit2))
                     {
                       clearInterval(that.interval)
                       that.disable = false
                     }
                 }, 10000)
               }
           }, 60000)
         }
       }
   },
   components: {
     my_image: MyImage,
     my_video: MyVideo,
     my_button: MyButton,
     pdf: pdfvuer,
     vue_markdown: VueMarkdown,
   }
 }
</script>

<style scoped>
 .Repecharge{
   margin-top: 6.5625vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   font-size: 1.3vw;
 }
  .splitView{
    margin: auto;
    width: 80%;
    display: flex;
    justify-content: space-around;
  }
  .preRules {
    flex-basis: 40%;
  }

  .buttons{
    flex-basis: 40%;
    display: flex;
    flex-direction: column;
  }
  .passed{
    background-color: #43dd37;
  }
  .meeting {
    background-color: #6367ff;
  }
 .tip{
   color: #F17C67;
   font-weight: 500;
   font-size: 26px;
   margin-top: 20px;
 }
 #rule{
   width: 50vw;
 }
 .split{
   width: 20px;
   height: 5px;
   margin-left: 20px;
 }
 .rules{
   margin-top: 30px;
   width: 80%;
   border: 5px dotted black;
   padding: 20px 40px;
 }
  .faq{
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .faq .q{
    font-weight: bold;
  }
  .faq .q::before{
    content: 'Q: '
  }
  .faq .a::before{
    content: 'A: '
  }
  .faq .img>img {
    margin: 20px 80px;
  }
.note {
  font-weight: 800;
}
.note > pre {
  display: inline-block;
}
.note > span {
  color: #CB4042;
}
</style>
